var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElistairLogoColorSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 189,
    viewBox: "0 0 315 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 188.58L22.99 141.43H291.2L314.19 188.58H0Z",
    fill: "#223735"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.89 0L97.9 47.15H22.99L0 0H120.89Z",
    fill: "#223735"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M314.199 0L291.209 47.15H218.439L195.449 0H314.209H314.199Z",
    fill: "#223735"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M192.32 0L169.43 46.93H145.43L122.54 0H70.6797L116.57 94.08H198.3L244.18 0H192.32Z",
    fill: "#223735"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElistairLogoColorSmall);
export default __webpack_public_path__ + "static/media/elistair-logo-color-small.f6c437f2e6c3c17939e0ae569d5fe1a5.svg";
export { ForwardRef as ReactComponent };